import SessionStorage from './SessionStorageService';

const USER_PREF = 'user_preferences';
export default {
  storePref(pref = {}) {
    const currentItem = SessionStorage.getItem(USER_PREF);
    SessionStorage.setItem(USER_PREF, { ...currentItem, ...pref });
  },
  readPref() {
    return SessionStorage.getItem(USER_PREF);
  },
};
